import { render, staticRenderFns } from "./ElementScalePlanTableColumn.vue?vue&type=template&id=51f7f2f6"
import script from "./ElementScalePlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePlanTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports